import React, { createContext } from 'react';

const PopupImageContext = createContext({});

export { PopupImageContext };
